import { render } from "./store.svg?vue&type=template&id=5675547d"
const script = {}
script.render = render

export default script